import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Button from '../../../shared/components/Button';

function VoteResultsTabs({ selected, onChange }) {
  const { t } = useTranslation();
  return (
    <>
      <Button
        background={selected === 'all' ? 'white' : 'blue'}
        text={t('poll_results_call_tab_1')}
        onClick={onChange('all')}
        border
        borderWhite
      />
      <Button
        background={selected === 'my' ? 'white' : 'blue'}
        text={t('poll_results_call_tab_2')}
        onClick={onChange('my')}
        border
        borderWhite
      />
    </>
  );
}

VoteResultsTabs.defaultProps = {
};

VoteResultsTabs.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.oneOf(['my', 'all']).isRequired,
};

export default VoteResultsTabs;
